import { gql } from '@apollo/client'

export const GET_ALL_PROCESSES = gql`
  query GetAllProcesses($searchQuery: String, $limit: Int, $offset: Int) {
    getAllProcesses(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
      count
      rows {
        id
        key
        name
        description
        ProcessesToProcessesCategories {
          id
          name
          description
        }
      }
    }
  }
`

export const GET_ONE_PROCESS_BY_ID = gql`
  query GetProcessById($getProcessByIdId: Int!) {
    getProcessById(id: $getProcessByIdId) {
      id
      key
      name
      description
      ProcessesToProcessesCategories {
        id
        name
        description
      }
    }
  }
`
